import React, { useContext } from 'react'
import { makeStyles } from 'tss-react/mui'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import Link from '../link/Link'
import styles from '../../styles'
import { WHITE } from '../../theme'
import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import links from '../../enums/linksEnum'
import { useNavigate } from 'react-router'
import { DEFAULT_OFFER_FILTERS } from '../../modules/rechercheOffre/utils/rechercheOffreConstants'

const Menu = () => {
	const navigate = useNavigate()
	const { isMenuLargeScreen, isLargeScreen } = useContext(ResponsiveContext)
	const { classes, cx } = useStyles({ isLargeScreen })

	const menuClass = cx(
		isMenuLargeScreen ? classes.menuLargeStyle : classes.menuSmallStyle,
		classes.menuWithMargin,
		classes.colorBlue,
		classes.menuStyle
	)

	const titleClass = cx(
		classes.text10,
		classes.titleStyle
	)

	return (
		<Grid container className={classes.menuContainer}>
			<Grid container item xs={12} className={menuClass}>
				<Grid container item xs={12} justifyContent="space-between">
					<Grid container item xs={6} md={isMenuLargeScreen ? 2 : 6} justifyContent="flex-start">
						<Link
							// Redirection vers la page de recherche d'offre avec un filtre par défaut sur toutes les offres
							href={`${links.RECHERCHE_OFFRE}${DEFAULT_OFFER_FILTERS}`}
							onClick={() => navigate({ pathname: links.RECHERCHE_OFFRE, search: DEFAULT_OFFER_FILTERS })}
							noAnimation
							hasChevron={false}
							prevent
						>
							<img
								src="/img/youFirstResidence.png"
								alt="YouFirst Campus"
								id="logo"
							/>
						</Link>
					</Grid>
					<Grid container item xs={6} alignItems="center" justifyContent="flex-end">
							<span className={titleClass}>
								<FormattedMessage
									id='global.title'
									defaultMessage="VISITEL"
									description="Titre"
								/>
							</span>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles<{ isLargeScreen: boolean }>()((theme, { isLargeScreen }) => ({
		...styles(theme),
		menuStyle: {
			display: 'flex',
			zIndex: 1,

			'& #logo': {
				cursor: 'pointer',
				width: 150
			}
		},
		menuContainer: {
			backgroundColor: WHITE,
			width: '100%',
			display: 'flex',
			justifyContent: 'center'
		},
		menuLargeStyle: {
			maxWidth: '100%',
			margin: 'auto',

			'& > div:first-child': {
				height: 82
			}
		},
		menuSmallStyle: {
			height: 50,
			zIndex: 3,
			marginTop: 15,
			marginBottom: 15,
			'& #logo': {
				width: 128,
				cursor: 'pointer'
			}
		},
		iconContainer: {
			width: 50,
			cursor: 'pointer',
			height: 50,
			padding: '15px 15px',
			borderRadius: 36,
			textTransform: 'inherit',
			backgroundColor: theme.palette.blue.main
		},
		menuWithMargin: {
			paddingLeft: isLargeScreen ? 60 : 30,
			paddingRight: isLargeScreen ? 60 : 30
		},
		titleStyle: {
			fontWeight: 700
		}
	})
)

export default Menu
